angular.module("digitalLeasing.module")
    .component("signatureMethod", {
        templateUrl: "ng/components/digitalLeasing/financialAppropriateVerification/signatureMethod/signatureMethod.view.html",
        bindings: {
            model: "=",
            onStructureChanges: "&",
            signExternal: '<',
            snapshot: '<',
            portalRunned: "<",
            postVendita: '='
        },
        controllerAs: "signatureMethodCtrl",
        controller: SignatureMethodController
    });

function SignatureMethodController(
    $portalService,
    $rootScope,
    $simulationService
) {
    var self = this;


    self.$onInit = function () {
        self.$rootScope = $rootScope;
        self.$portalService = $portalService;
        self.$simulationService = $simulationService;



        self.supportModel = {
            firmaAlbaLeasing: {
                selected: false
            }
        }

        if (!self.postVendita) {
            self.supportModel.firmaAlbaLeasing.selected = !self.model.leasingData.preventivo.firmaDigitaleEsterna;
            console.log("NON SONO POSTVENDITA");
            
        }


        //RN:12378303
        // se non ho tutti i certificati validi non posso usare SPID
        self.model.financialCustomer.tuttiCertificatiValidi = true;
        self.model.leasingData.preventivo.firmaDigitalePersonale = self.model.leasingData.preventivo.firmaDigitaleEsterna

        $simulationService.getLinkedPersonContract(
            self.model.leasingData.id, 
            false, 
            self.model.financialCustomer.metadata.riUserF.listaPf, 
            self.model.leasingData.monitor,
            self.model.leasingData.preventivo.firmaDigitale, 
            self.model.leasingData.preventivo.firmaDigitaleEsterna, 
            self.model.leasingData.preventivo.smallTicket, 
            false)
            .then(function (response) {
                if (response.success) {
                    console.log(response);
                    const firmatari = response.persons.filter(f => f && f.firmatario && f.firmatario.selected);
                    const esisteCertificatoNonValido = firmatari.some(f => !f.certificate || !f.certificate.valid );

                    self.model.financialCustomer.tuttiCertificatiValidi = !esisteCertificatoNonValido;
                    console.log("CERTIFICATI TUTTI VALIDI ::::", !esisteCertificatoNonValido);                    

                    if(self.model.leasingData.preventivo.firmaDigitale == true) {
                        //RN:12378303

                        if (self.model.financialCustomer.tuttiCertificatiValidi) {
                            // capire cosa fare , c'è da impostare quelche valore prefeinito ?
                            //self.model.leasingData.preventivo.firmaDigitalePersonale = null;
                            self.supportModel.firmaAlbaLeasing.selected = !self.model.leasingData.preventivo.firmaDigitalePersonale;
                            
                        } else {
                            self.model.leasingData.preventivo.firmaDigitalePersonale = true;
                            self.model.leasingData.preventivo.firmaDigitaleEsterna = true;
                            self.supportModel.firmaAlbaLeasing.selected = false;

                        }

                    } else {
                        self.model.leasingData.preventivo.firmaDigitalePersonale = null;
                    }




                }
            })
            .catch(function (error) {
                console.log(error)
            })


		//RN:12255567
		//Se sono slim leasing martello la risposta a si e disabilito la posibilita di scelta
		if(self.model.leasingData.preventivo.slimLeasing) {
			self.model.leasingData.preventivo.firmaDigitale = true;
			self.visualModifyButton = true;
			self.canModifyFields = false;
		} else {
			if (!self.postVendita && getWizardMap(self.model.viewIndex) == "M17") {
			    self.visualModifyButton = true;
			    self.canModifyFields = false;
			} else {
			    self.canModifyFields = true;
			    self.visualModifyButton = false;
			}
		}
	


    };

    self.$onChanges = function (changed) {
        if (changed.signExternal && changed.signExternal.currentValue) {
            if (self.postVendita) {
                self.model.destinatario.firmaDigitaleEsterna = true;
            } else {
                self.model.leasingData.preventivo.firmaDigitaleEsterna = true;
            }
        }
    }

    self.handleChange = function (property, value) {
        if (self.postVendita) {
            self.model.destinatario[property] = value;
            self.onStructureChanges({
                signatureStructure: self.model.destinatario.firmaDigitale
            });
        } else {
            if (property === 'firmaDigitale') {

                //RN:12378303
                if (!self.model.financialCustomer.tuttiCertificatiValidi){
                    self.model.leasingData.preventivo.firmaDigitalePersonale = true;
                }                
                self.model.leasingData.preventivo.firmaDigitale = value;
                console.log("Signature Method: ", self.model);
            }
            self.onStructureChanges({
                signatureStructure: self.model.leasingData.preventivo.firmaDigitale
            });
        }


    }

    self.check = function (el) {
        el.selected = !el.selected;

        if (self.postVendita) {
            self.model.destinatario.firmaDigitaleEsterna = !el.selected;
        } else {
            self.model.leasingData.preventivo.firmaDigitaleEsterna = !el.selected;
        }

        self.handleChange("firmaEsterna", 'qualsiasi valore'); //controllo aggiunto per far partire la funzione di esportazione del cambiamento firma    
    };

    self.enableDisableModify = function () {
        self.canModifyFields = !self.canModifyFields;
    }

    var getWizardMap = function (viewIndex) {
        return $rootScope.wizardMap
            .find(function (element) {
                return element.index == viewIndex
            }).viewName
    }

    self.radioModify = function (tipo, valore) {
        if (tipo == 'firmaDigitalePersonale') {
            self.supportModel.firmaAlbaLeasing.selected = !valore;
            self.model.leasingData.preventivo.firmaDigitaleEsterna = valore; 
        }
    }

}